import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import Apis from '../../api';
import { HEADERMENU_PATH } from '../../routes/RoutesURL';
import ForgotPassword from '../forgotPassword/ForgotPassword';
import ForgotPasswordMessage from '../forgotPassword/ForgotPasswordMesage';
import ResetPassword from '../forgotPassword/ResetPassword';
import Login from '../login/Login';
import ResendActivationEmail from '../login/ResendActivationEmail';
import SignUp from '../signUp/SignUp';
import SignUpThankYou from '../signUp/Thankyou';
import LandingLeftSection from './LandingLeft';
import LandingRightSection from './LandingRight';

// import MessageActions from '../message/redux/actions';

const LandingPage: React.FC = () => {
    const referral_code = useParams().referralCode;

    const pathName = window.location.pathname;

    const [userName, setUsername] = useState<string | undefined>(undefined);
    const [referralError, setReferralError] = useState<string | undefined>(undefined);

    const scrollDown = () => {
        const referralDiv = document.getElementById('referral_sign_up_div');
        if (referralDiv) {
            const top = referralDiv.offsetTop;
            window.scrollTo({ top: top });
        }
    };

    const headTitle = useMemo(() => {
        if (pathName.includes(HEADERMENU_PATH.referralSignUp)) {
            return [{ title: 'Referral Signup', path: `${HEADERMENU_PATH.referralSignUp}${referral_code}` }];
        }
        switch (pathName) {
            case HEADERMENU_PATH.login:
            case HEADERMENU_PATH.signUp:
                return [
                    { title: 'Login', path: HEADERMENU_PATH.login },
                    { title: 'Signup', path: HEADERMENU_PATH.signUp },
                ];

            case HEADERMENU_PATH.signUpSuccess:
            case HEADERMENU_PATH.resendActivateEmail:
                return [{ title: 'Account Activation', path: pathName }];
            default:
                return [{ title: 'Reset Password', path: pathName }];
        }
    }, [pathName, referral_code]);

    const component = useMemo(() => {
        if (pathName.includes(HEADERMENU_PATH.referralSignUp)) {
            return <SignUp referralError={referralError} referral_code={referral_code} />;
        }
        switch (pathName) {
            case HEADERMENU_PATH.login:
                return <Login />;
            case HEADERMENU_PATH.signUp:
                return <SignUp referralError={referralError} />;
            case HEADERMENU_PATH.forgotPassword:
                return <ForgotPassword />;
            case HEADERMENU_PATH.resetPassword:
                return <ResetPassword />;
            case HEADERMENU_PATH.resendActivateEmail:
                return <ResendActivationEmail />;
            case HEADERMENU_PATH.signUpSuccess:
                return <SignUpThankYou />;
            case HEADERMENU_PATH.forgotPasswordMessage:
                return <ForgotPasswordMessage />;
            default:
                return null;
        }
    }, [pathName, referralError, referral_code]);

    const topView = useMemo(() => {
        if (pathName.includes(HEADERMENU_PATH.referralSignUp) && referral_code) {
            return (
                <p
                    className="w-full text-center text-xl mx-auto font-semibold lg:text-2xl xl:text-3xl text-white py-4 pb-1 px-3.5 pt-1 md:pt-10"
                    style={{ fontFamily: 'WorkSans-Semibold' }}
                >
                    {userName ? `${userName} has invited you` : 'You have been invited'} to discover Helicap's selection
                    of <br /> Private Investment Opportunities
                </p>
            );
        }
        return (
            <p
                className="w-full text-center text-xl mx-auto lg:text-2xl font-semibold xl:text-3xl text-white py-4 pb-1 px-3.5 pt-1 md:pt-10"
                style={{ fontFamily: 'WorkSans-Semibold' }}
            >
                Discover Helicap's selection of <br /> Private Investment Opportunities
            </p>
        );
    }, [referral_code, userName, pathName]);

    useEffect(() => {
        if (referral_code) {
            Apis.getUserNameByReferralCode(referral_code)
                .then((res) => {
                    if (res && res.data) {
                        setUsername(res.data.name);
                    }
                })
                .catch(() => {
                    setUsername(undefined);
                    setReferralError(
                        'Invalid Referral Code - You can still signup and add referral code later within 14 days of signing-up',
                    );
                });
        }
    }, [referral_code]);

    return (
        <div id="landing" className="lg:grid lg:grid-cols-2 w-full min-h-screen h-auto">
            <LandingLeftSection
                referral_code={referral_code}
                topText={topView}
                scrollDown={referral_code ? scrollDown : undefined}
            />

            <LandingRightSection
                pathName={pathName}
                referral_code={referral_code}
                headTitle={headTitle}
                id={referral_code ? 'referral_sign_up_div' : ''}
            >
                {component}
            </LandingRightSection>
        </div>
    );
};

export default LandingPage;
